import { useData } from '../store';
import { Button } from './Button';

// Состояние связи: цвет точки на моём кружке в шапке и текст тултипа.
export const CONNECTION = {
  connecting: { text: 'Connecting…', dot: 'bg-gray-400' },
  online: { text: 'Live', dot: 'bg-green-600' },
  reconnecting: { text: 'Reconnecting…', dot: 'bg-amber-500' },
  paused: { text: 'Paused', dot: 'bg-gray-400' },
  offline: { text: 'Offline', dot: 'bg-danger' },
} as const;

/** Старт не удался (снимок или настройки не прочитались): причина и Reload вместо вечного «Loading…». */
export function StoreError() {
  const status = useData((s) => s.status);
  const error = useData((s) => s.error);
  if (status !== 'error') return null;
  return (
    <div className="flex-1 flex items-center justify-center p-6" data-store-error>
      <div className="max-w-md bg-paper border border-line rounded-xl p-8 text-center">
        <h1 className="text-2xl font-bold mb-2">Could not load the roadmap</h1>
        <p className="text-danger mb-4">{error}</p>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </div>
  );
}
